"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGuideUI = void 0;
const react_1 = require("react");
/**
 * Custom state hook for accessing localStorage setting for show/hide guide UI
 */
function useGuideUI() {
    const [showGuideUI, setShowGuideUI] = (0, react_1.useState)(getGuideSettingsLocalStorage());
    const handleSetShowGuideUI = (newValue) => {
        setGuideSettingsLocalStorage(newValue);
        setShowGuideUI(newValue);
    };
    return { guideUI: showGuideUI, setGuideUI: handleSetShowGuideUI };
}
exports.useGuideUI = useGuideUI;
function getGuideSettingsLocalStorage() {
    const storedValue = localStorage.getItem('streemGuideUIVisible');
    if (storedValue === 'false') {
        return false;
    }
    else {
        return true;
    }
}
function setGuideSettingsLocalStorage(value) {
    localStorage.setItem('streemGuideUIVisible', value.toString());
}
//# sourceMappingURL=use_guide_ui.js.map